import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faUsers,
    faUserGraduate,
    faSchool,
    faBook,
    faTasks,
    faChartBar,
    faClipboardList,
    faPowerOff,
} from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
    const navigate = useNavigate();
    const [usuario, setUsuario] = useState("");
    const [rol, setRol] = useState("");
    const [isOpen, setIsOpen] = useState(false); // Estado para controlar el menú

    useEffect(() => {
        const nombre = localStorage.getItem("nombre");
        const role = localStorage.getItem("tipo_usuario");
        if (nombre) setUsuario(nombre);
        if (role) setRol(role);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("auth");
        localStorage.removeItem("rol");
        navigate("/login");
    };

    const handleNavLinkClick = () => {
        setIsOpen(false); // Cierra el menú al hacer clic en una opción
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-3">
            <Link className="navbar-brand" to="/" onClick={handleNavLinkClick}>
                <FontAwesomeIcon icon={faHome} />
            </Link>
            <button
                className="navbar-toggler"
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarNav">
                <ul className="navbar-nav">
                    {rol === "admin" && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/usuarios" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faUsers} /> Usuarios
                            </Link>
                        </li>
                    )}
                    {(rol === "admin" || rol === "maestro") && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/alumnos" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faUserGraduate} /> Asignación
                            </Link>
                        </li>
                    )}
                    {rol === "admin" && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/grados" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faSchool} /> Grados
                            </Link>
                        </li>
                    )}
                    {rol === "admin" && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/materias" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faBook} /> Materias
                            </Link>
                        </li>
                    )}
                    {(rol === "admin" || rol === "maestro") && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/actividades" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faTasks} /> Actividades
                            </Link>
                        </li>
                    )}
                    {(rol === "admin" || rol === "maestro" || rol === "padre") && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/resultadosActividades" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faChartBar} /> Resultados de Actividades
                            </Link>
                        </li>
                    )}
                    {(rol === "admin" || rol === "maestro" || rol === "padre") && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/notas" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faClipboardList} /> Notas Finales
                            </Link>
                        </li>
                    )}
                    {(rol === "admin" || rol === "maestro" || rol === "padre") && (
                        <li className="nav-item">
                            <Link className="nav-link" to="/notasxAlumno" onClick={handleNavLinkClick}>
                                <FontAwesomeIcon icon={faClipboardList} /> Notas por Alumno
                            </Link>
                        </li>
                    )}
                </ul>

                <ul className="navbar-nav d-flex align-items-center">
                    {usuario && (
                        <li className="nav-item">
                            <span className="nav-link text-white">Hola, {usuario}</span>
                        </li>
                    )}
                    <li className="nav-item">
                        <button className="btn btn-outline-danger border-0" onClick={handleLogout}>
                            <FontAwesomeIcon icon={faPowerOff} size="lg" />
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Navbar;
